import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideos: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="videos,video-playlist"><path d="M4.75 3.75H19.25M11.5 13.25H12M2.75 6.25H21.25V20.25H2.75V6.25ZM10.75 11V15.5L13.75 13.25L10.75 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVideos;
